import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

export default function Breadcrumb() {
  const navigate = useNavigate();
  const location = useLocation();

  if (
    location.pathname === "/shop" ||
    location.pathname === "/invoices" ||
    location.pathname.includes("/orders")
  ) {
    return null;
  }

  return (
    <p
      className="gap-2 text-base font-bold flex items-center  text-primeColor px-4 py-2 cursor-pointer"
      onClick={() => navigate("/shop")}
    >
      <FaArrowLeft />
      Continue Shopping
    </p>
  );
}
